import React from "react";
import {
  ContentsFlexWrap,
  FooterInformation,
  LogoLink,
  NavContentsWrap,
  NavContents,
  NavItem,
  NavItemLink,
  FooterSection,
  LinkButtonWrap,
  PCLinkListWrap,
  StyledLink,
  Wrap,
  LinkListWrap,
  SPLinkListWrap,
  LogoImg,
} from "./elements";
import { MenuLabelList } from "../Header";
import Logo from "../../assets/images/bestvalue_logo.svg";

export const Footer: React.FC = React.memo(() => {
  return (
    <FooterSection>
      <Wrap>
        <SPLinkListWrap>
          <LinkButtonWrap>
            <StyledLink isline={false}>申し込みはこちら</StyledLink>
          </LinkButtonWrap>
          <LinkButtonWrap>
            <StyledLink isline>LINE登録はこちら</StyledLink>
          </LinkButtonWrap>
        </SPLinkListWrap>
        <ContentsFlexWrap>
          <FooterInformation>
            <PCLinkListWrap>
              <LinkButtonWrap>
                <StyledLink isline={false}>申し込みはこちら</StyledLink>
              </LinkButtonWrap>
              <LinkButtonWrap>
                <StyledLink isline>LINE登録はこちら</StyledLink>
              </LinkButtonWrap>
            </PCLinkListWrap>
            <LinkListWrap>
              <LogoLink>
                <LogoImg alt="logo" src={Logo} />
              </LogoLink>
            </LinkListWrap>
          </FooterInformation>
          <NavContentsWrap>
            <NavContents>
              {MenuLabelList.map((item) => (
                <NavItem key={item.label}>
                  <NavItemLink href={item.link}>{item.label}</NavItemLink>
                </NavItem>
              ))}
            </NavContents>
          </NavContentsWrap>
        </ContentsFlexWrap>
      </Wrap>
    </FooterSection>
  );
});

Footer.displayName = "Footer";
